const styles = () => ({
  root: {
    flex: '1 1 auto',
    overflow: 'auto',
    background: '#FAFBFC',
    padding: '47px 69px',
    width: 415,
  },

  avatarWrap: {
    flex: 'none',
    margin: '0 20px 0 0',
    width: 47,
    height: 47,
    overflow: 'hidden',
    borderRadius: '50%',
    boxShadow: '0 1px 2px rgba(49, 73, 116, .20)',
  },

  avatar: {
    display: 'block',
    width: 47,
  },

  header: {
    display: 'flex',
    alignItems: 'center',
  },

  title: {
    fontSize: 30,
    color: '#414953',
    fontWeight: 500,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0,
  },

  row: {
    flex: '0',
    fontSize: 15,
    margin: '27px 0 0 0',
    lineHeight: '1.4em',
  },

  key: {
    color: '#A9B0B8',
  },

  value: {
    color: '#414953',
  },

  ellipsis: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0,
  },

  link: {
    color: '#5786D7',
  },

  socialLink: {
    color: '#5786D7',
    width: 18,
    height: 18,
    display: 'block',
    margin: '0 32px 0 0',
  },

  socialBar: {
    display: 'flex',
    margin: '27px 0 0 0',
  },

  person: {
    margin: '0 0 34px 0',
    padding: '0 0 34px 0',
    borderBottom: '1px solid #F3F4F5',
  },

  sep: {
    height: 1,
    background: '#F3F4F5',
    margin: '34px 0',
  },
});

export default styles;
